import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { SiaSizeDetectorService, SiaTranslatePipe } from '@sia/shared';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import {
  DxiColumnModule,
  DxoColumnChooserModule,
  DxoEditingModule,
  DxoFilterRowModule,
  DxoGroupPanelModule,
  DxoGroupingModule,
  DxoHeaderFilterModule,
  DxoLoadPanelModule,
  DxoLookupModule,
  DxoRemoteOperationsModule,
  DxoScrollingModule,
  DxoSearchPanelModule,
  DxoSelectionModule,
  DxoSortingModule,
} from 'devextreme-angular/ui/nested';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-actions',
  templateUrl: './sia-grid-config-actions.component.html',
  styleUrls: ['./sia-grid-config-actions.component.scss'],
  providers: [
    {
      provide: SiaGridConfigTab,
      useExisting: SiaGridConfigActionsComponent,
    },
  ],
  standalone: true,
  imports: [
    DxDataGridModule,
    DxiColumnModule,
    DxoLookupModule,
    DxoEditingModule,
    DxoSelectionModule,
    DxoRemoteOperationsModule,
    DxoSortingModule,
    DxoColumnChooserModule,
    DxoLoadPanelModule,
    DxoHeaderFilterModule,
    DxoFilterRowModule,
    DxoSearchPanelModule,
    DxoGroupPanelModule,
    DxoGroupingModule,
    DxoScrollingModule,
    SiaTranslatePipe,
  ],
})
export class SiaGridConfigActionsComponent
  extends SiaGridConfigTab
  implements OnInit, OnDestroy
{
  @ViewChild(DxDataGridComponent, { static: false })
  childDataGrid: DxDataGridComponent | undefined;

  gridConfTemplateTypes: any[] = [
    { id: 'ActionGeneric', name: 'ActionGeneric' },
    { id: 'ActionPK', name: 'ActionPK' },
    { id: 'GroupPK', name: 'GroupPK' },
    { id: 'ActionDownload', name: 'ActionDownload DEPRECATO' },
    // { id: 'ActionLink', name: 'ActionLink' },
    { id: 'ActionLinkMaterial', name: 'ActionLinkMaterial DEPRECATO' },
    { id: 'ActionMaterial', name: 'ActionMaterial' },
  ];

  private sizeDetector = inject(SiaSizeDetectorService);
  @HostListener('window:unload')
  ngOnDestroy() {
    if (this.childDataGrid && this.childDataGrid.instance) {
      this.childDataGrid.instance.dispose();
      this.childDataGrid = undefined;
    }
    this.gridConfTemplateTypes = [];
    super.ngOnDestroy();
  }

  onInitNewRow(e: any) {
    e.data.visible = true;
    e.data.cellTemplate = 'ActionPK';
    e.data.onlyAdmin = true;
  }
}
